import React from 'react';
import './StatCard.css';

/**
 * StatCard - Componente reutilizable para mostrar estadísticas
 * 
 * @param {string} label - Etiqueta de la estadística
 * @param {string|number} value - Valor principal
 * @param {string} icon - Emoji o icono
 * @param {string} detail - Detalle adicional (opcional)
 * @param {string} className - Clases CSS adicionales
 * @param {string} trend - 'up' | 'down' | 'neutral' (opcional)
 * @param {function} onClick - Callback al hacer click (opcional)
 */
export default function StatCard({ 
  label, 
  value, 
  icon, 
  detail, 
  className = '', 
  trend,
  onClick 
}) {
  const trendClass = trend ? `stat-card--${trend}` : '';
  const clickableClass = onClick ? 'stat-card--clickable' : '';
  
  return (
    <div 
      className={`stat-card ${trendClass} ${clickableClass} ${className}`}
      onClick={onClick}
    >
      {icon && <div className="stat-card__icon">{icon}</div>}
      
      <div className="stat-card__content">
        <p className="stat-card__label">{label}</p>
        <h3 className="stat-card__value">{value}</h3>
        {detail && <p className="stat-card__detail">{detail}</p>}
      </div>
      
      {trend && (
        <div className="stat-card__trend">
          {trend === 'up' && '↗'}
          {trend === 'down' && '↘'}
          {trend === 'neutral' && '→'}
        </div>
      )}
    </div>
  );
}
